import { MediaserverAudioSetting } from 'features/mediaserver-settings/domain/models/mediaserver-audio-setting';
import {
  useReadMediaserverAudioSettingQuery,
  useUpdateMediaserverAudioSettingMutation,
} from 'features/mediaserver-settings/domain/queries/media-audio-queries';

export interface IMediaserverAudioSettingHook {
  isLoadingMediaserverAudioSetting: boolean;

  mediaserverAudioSetting: MediaserverAudioSetting;
  setMediaserverAudioSetting: (value: MediaserverAudioSetting) => void;
}

const useMediaserverAudioSetting = (): IMediaserverAudioSettingHook => {
  const {
    isLoading: isLoadingMediaserverAudioSetting,
    data: mediaserverAudioSettingResponse,
    isFetching: isFetchingMediaserverAudioSetting,
  } = useReadMediaserverAudioSettingQuery();
  const { mutate: executeUpdateMediaserverAudioSetting, isPending: isLoadingUpdateMediaserverAudioSetting } =
    useUpdateMediaserverAudioSettingMutation();

  const setMediaserverAudioSetting = (value: MediaserverAudioSetting) => {
    executeUpdateMediaserverAudioSetting({
      mediaserverAudioSetting: value,
    });
  };

  const mediaserverAudioSetting = () =>
    mediaserverAudioSettingResponse?.mediaserverAudioSetting ?? MediaserverAudioSetting.MediaserverAudioDisabled;

  return {
    isLoadingMediaserverAudioSetting:
      isLoadingMediaserverAudioSetting || isFetchingMediaserverAudioSetting || isLoadingUpdateMediaserverAudioSetting,

    mediaserverAudioSetting: mediaserverAudioSetting(),
    setMediaserverAudioSetting,
  };
};

export default useMediaserverAudioSetting;
